import { Dialog, DialogTitle } from "@headlessui/react";

import Button from "../../../components/atoms/button";
import { useLazySendLoginActivityQuery } from "../../../store/slices/api/userInfoApiSlice";
import { useKeycloak } from "@react-keycloak/web";
import { UserInfoSliceActions } from "../../../store/slices/userInfoSlice";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { RootState } from "@lxp-app/store/store";
import { getAuthoringLibraryLabel } from "@lxp-app/utils/authoringLibraryResources/localizeAuthoringLibraryLabels";

interface DialogProps {
  onConfirm: () => void;
  setOpen: (val: boolean) => void;
}

const LogoutConfirmationModal = ({ setOpen }: DialogProps) => {
  const closeModal = () => {
    setOpen(false);
  };

  const [sendLoginActivity] = useLazySendLoginActivityQuery();
  const { keycloak } = useKeycloak();
  const dispatch = useDispatch();
  const userProfile = useSelector(
    (state: RootState) => state?.UserInfoSlice?.profile
  );
  const language = userProfile?.preferences?.language || "en";
  const hasAssessmentRecOrgs = userProfile?.hasAssessmentRecOrgs;

  return (
    <>
      <div className=" w-full ">
        <div className="my-3 ml-4 mt-0 text-left">
          <DialogTitle
            as="h3"
            className="text-xl max-sm:text-lg font-semibold leading-6 text-gray-900 dark:text-gray-50 mt-7"
          >
            {getAuthoringLibraryLabel("logoutConfirmTitle", language)}
          </DialogTitle>
          <div className="my-4 text-gray-500 dark:text-gray-400">
            {getAuthoringLibraryLabel("logoutConfirmDescription", language)}
          </div>
        </div>
      </div>
      <div className="mt-6 pt-4 sm:mt-4 mr-2 flex gap-2 justify-end space-x-2 md:mb-3 mb-5">
        <Button
          label={getAuthoringLibraryLabel("stayEngaged", language)}
          variant="outlined"
          buttonColor="secondary"
          onClick={closeModal}
          testId="closeModalBtn"
        />
        <Button
          label={getAuthoringLibraryLabel("logout", language)}
          type="button"
          onClick={() => {
            if (keycloak.authenticated) {
              sendLoginActivity("logout").then((res: any) => {
                dispatch(UserInfoSliceActions.setFirstTimeLogin(false));
                keycloak.logout({
                  redirectUri:
                    window.location.origin +
                    "/logout" +
                    `?org=${userProfile?.isHitachiOrg ? "hitachi" : userProfile?.isTMobileOrg ? "t-mobile" : ""}`
                });
              });
              sessionStorage.clear();
            }
          }}
          data-testid="loginLogoutBtn"
          statements={[
            {
              eventName: "onClick",
              verb: {
                id: keycloak.authenticated
                  ? "PLATFORM_LOGOUT"
                  : "PLATFORM_LOGIN",
                display: {
                  "en-US": keycloak.authenticated ? "Log out" : "Log in"
                }
              },
              object: {
                objectType: keycloak.authenticated
                  ? "USER_LOGOUT"
                  : "USER_LOGIN",
                id: keycloak.authenticated ? "Log out" : "Log in"
              }
            }
          ]}
          variant="contained"
          buttonColor="primary"
          testId="loginLogoutBtn"
        />
      </div>
    </>
  );
};

export default LogoutConfirmationModal;
